module.exports = __webpack_public_path__ + "img/avatar_of_vengeance_small.a767f69a.png";